<template>
  <TooltipRoot
    :open="isOpen"
    :disabled="props.disabled"
    :disable-hoverable-content="!props.interactive"
    :delay-duration="delayDuration || 300"
    @update:open="open = $event"
  >
    <slot></slot>
  </TooltipRoot>
</template>

<script setup lang="ts">
import { TooltipRoot } from "reka-ui";
import { ref, toRef } from "vue";

const props = defineProps<{
  disabled?: boolean;
  interactive?: boolean;
  delayDuration?: number;
  alwaysShow?: boolean;
}>();

// We have to make the open state controlled just to have the option to
// force-show in some scenarios, awful.
const open = ref(false);
const isOpen = toRef(() => !props.disabled && (props.alwaysShow || open.value));
</script>
